namespace Nobox {

    @Serenity.Decorators.registerEditor('Nobox.SelectAgentEditor')
    export class SelectAgentEditor extends Serenity.Extensions.GridEditorBase<Administration.UserRow> {
        protected getColumnsKey() { return SelectAgentColumns.columnsKey; }
        protected getDialogType() { return Administration.UserDialog; }
        protected getLocalTextPrefix() { return Administration.UserRow.localTextPrefix; }

        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', 'select', e => {
                var cell = this.slickGrid.getCellFromEvent(e);
                if (!cell)
                    return;

                var item = this.itemAt(cell.row);
                var field = this.slickGrid.getColumns()[cell.cell].field;
                item[field] = Q.toId($(e.target).val());
                this.view.updateItem(this.id(item), item);
            });
        }

        protected getButtons() {
            return [];
        }

        protected createToolbarExtensions() {
            super.createToolbarExtensions();

            Serenity.Widget.create({
                type: Serenity.ServiceLookupEditor,
                options: {
                    idField: "UserId",
                    textField: "DisplayName",
                    service: "/Services/Administration/User/ListAgent",
                    //includeColumns: ["Id", "Nama", "TipeNama"],
                    //dialogType: "Link.Masjid.M3Kontak",
                    //inplaceAdd: true,
                    //inplaceAddPermission: "Administration.General",
                    sort: [],
                    pageSize: 10
                },
                element: e => e.attr('placeholder', '--select agents--')
                    .css('float', 'left')
                    .appendTo(this.toolbar.element),
                init: w => w.change(x => {
                    if (Q.isEmptyOrNull(w.value))
                        return;

                    if (Q.any(this.getItems(), i => i.UserId == Number(w.value))) {
                        Q.notifyWarning("Agent have been added!");
                        return;
                    }

                    var item: Administration.UserRow = {
                        UserId: Number(w.value),
                        DisplayName: w.text,
                    };

                    this.setNewId(item);

                    var items = this.getItems().slice();
                    items.push(item);
                    items.sort((a, b) => Q.turkishLocaleCompare(a.DisplayName, b.DisplayName));
                    this.setItems(items);
                    w.value = null;
                })
            });
        }

        protected getColumns() {
            var columns = super.getColumns();

            columns.unshift({
                field: 'Remove Attendee',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-times text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            Q.first(columns, x => x.field === Administration.UserRow.Fields.DisplayName).format = (ctx) => {
                if (Q.isEmptyOrNull(ctx.item.ContactTipeNama)) {
                    return ctx.value;
                } else {
                    return `${ctx.value} [ ${ctx.item.ContactTipeNama} ]`;
                }
            };

            return columns;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm("Delete this record?", () => {
                        var items = this.getItems();
                        items.splice(row, 1);
                        this.setItems(items);
                    })
                }
            }
        }

        // Tambahan
        protected getSlickOptions(): Slick.GridOptions {
            var opt = super.getSlickOptions();
            opt.enableTextSelectionOnCells = true;
            opt.selectedCellCssClass = "slick-row-selected";
            opt.enableCellNavigation = true;
            return opt;
        }

        protected createSlickGrid(): Slick.Grid {
            var grid = super.createSlickGrid();
            grid.setSelectionModel(new Slick.RowSelectionModel());
            return grid;
        }

    }
}
